import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgPricing(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "pricing_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#pricing_svg__a)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, {
      children: [_jsx("path", {
        d: "M11.769 18.011a25.866 25.866 0 00-3.816 17.875 25.959 25.959 0 008.963 15.956 26.27 26.27 0 0017.315 6.155 26.259 26.259 0 0017.115-6.686 25.946 25.946 0 008.46-16.225 25.873 25.873 0 00-4.373-17.748A26.164 26.164 0 0040.388 6.83 26.318 26.318 0 0022.1 8.756",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M4 18.71l8.814-3.447 3.436 8.67M33.784 6.38v5.485",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M33.779 19.038v2.278M33.779 42.973v2.278",
        stroke: "#FF6652"
      }, void 0), _jsx("path", {
        d: "M33.784 52.075v5.72M60 31.981h-5.763",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M39.024 25.354a5.39 5.39 0 00-1.93-2.905 5.449 5.449 0 00-3.315-1.127c-2.991 0-5.422 1.901-5.422 4.884 0 2.983 1.974 4.453 5.422 5.928 3.447 1.475 5.421 2.94 5.421 5.928s-2.425 4.878-5.421 4.878a5.45 5.45 0 01-3.218-1.053 5.394 5.394 0 01-1.962-2.744",
        stroke: "#FF6652"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgPricing;